// extracted by mini-css-extract-plugin
module.exports = {"Container":"Board_Container__2WRI_","Board":"Board_Board__3qumj","Button":"Board_Button__38H1a"};